import { Injectable } from '@angular/core';

// SERVICES
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

import { ProductTagService } from '@app/core/product-tags/services/product-tag.service';

import { ITagOld } from './interfaces';
import { TagStateService } from './tag-state.service';

@Injectable({
  providedIn: 'root',
})
export class TagFacadeService {
  constructor(
    private tagStateService :TagStateService,
    private productTagService :ProductTagService,
  ) {}

  getTags(data :{
    params :{ [param :string] :string | string[] };
    cache ?:boolean;
  }) :Observable<ITagOld[]> {
    const { params, cache = false } = data;
    this.tagStateService.updateState({ loading: true });

    return this.productTagService.getV2(params, cache).pipe(
      finalize(() => this.tagStateService.updateState({ loading: false })),
      tap((tags :ITagOld[]) => {
        this.tagStateService.updateState({ tags });
      }),
    );
  }

  get tags$() :Observable<ITagOld[]> {
    return this.tagStateService.tags$;
  }

  get selectedTags$() :Observable<ITagOld[]> {
    return this.tagStateService.selectedTags$;
  }

  get currentQueryParams() :{ [param :string] :string | string[] } {
    return this.tagStateService.state.currentQueryParams;
  }
}
